/**
 * Reducer for the list of potential countries
 * TODO: Q: WHAT if we had a config reducer? COntained constants that were passed in from config?
 * TODO: OR we have a client-side config file?
 */

import _ from 'lodash'
import { ActionTypes as types } from '../constants'

// get hydration data from server
import serverProps from '../lib/server-props'

// [ { name, countryCode, currencyCode } ]
const {
  sendableCountryList: countries = [], //  All countries we can send to (both via P2p / XOOM).
  xoomCountryOptions,
  hideXoomDistributionOptions, // determines whether Xoom integration is ready to show the new distribution options page
} = serverProps

// { US: { name, countryCode, currencyCode, /* ... */ }
const countriesByCode = _.keyBy(countries, 'countryCode')

// create the initial state
const initialState = {
  countries,
  countriesByCode,
  countryData: null,
  isFetchingCountryData: false,
  xoomCountryOptions,
  hideXoomDistributionOptions,
}

/**
 * This reducer returns the country list.
 */
export default function countryReducer(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVED_COUNTRY_DATA:
      return {
        ...state,
        countryData: {
          ...action.data,
        },
        isFetchingCountryData: false,
      }

    case types.REQUEST_COUNTRY_DATA:
      return {
        ...state,
        countryData: null,
        isFetchingCountryData: true,
      }

    case types.INVALIDATE_COUNTRY_DATA_CACHE:
      return {
        ...state,
        countryData: null,
      }

    case types.SHOW_ERROR_BANNER:
      return {
        ...state,
        isFetchingCountryData: false,
      }

    default:
      return state
  }
}
